import {
  useLoaderData,
  Form,
  useSubmit,
} from "react-router-dom";
import { useState, useEffect } from 'react'
import ArticleGrid from "../components/grid";
import { randomInt } from "../utils/randomInt";

export async function loader({ request }) {
  const url = new URL(request.url);
  const URITags = url.searchParams.get("tags") === null ? [] : url.searchParams.get("tags");
  return { URITags };
}

export async function action({ params }) {
  return null;
}

export default function Resume() {
  const { URITags } = useLoaderData();
  const submit = useSubmit();
  const [tags, setTags] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [windowSize, setWindowSize] = useState({width: 500, height: 500});
  const [columnCount, setColumnCount] = useState(1);

  // Retrieve tags from search query "Search?Tags=tag1,tag2,-tag3"
  function parseTagsFromURI()
  {
    const cTags = String(URITags);
    parseTags(cTags, false);
  }

  // Keep track of windows size so the grid can consume a consisted ratio of the screen
  useEffect(() => {
    window.addEventListener("resize", () => {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
      setColumnCount(((window.innerWidth * .98) / 32) | 0);
    });

    setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    setColumnCount(((window.innerWidth * .98) / 32) | 0);
  }, []);

  // Parse tags from uri search string.
  // INFO: comment inside suppresses warning.
  useEffect(() => {
    parseTagsFromURI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [URITags]);

  // Retrieve tags from user text box input.
  // Typing "tag2" in the search box then clicking the Submit button, or pressing enter, adds tag2 to end of the existing tags.
  function parseTagsFromInput()
  {
    const searchString = document.getElementById("SearchField").value;
    parseTags(searchString, true);
  }

  // Parses tags from input then, depending on IsAddative===true/false,
  // add the new tags to the current list of tags or replace the tag list with the new tags.
  function parseTags(text, IsAddative)
  {
    let newTags = [];
    if (text !== null && text !== '')
      newTags = text.toLowerCase().split(','); // Only split if there's text, otherwise leave the []

    setTags(IsAddative ? tags.concat(newTags) : newTags);
  }

  // From the selected tag element, find and remove it from the tags list, then update the tags state
  function removeTag(el)
  {
    const tagName = el.target.innerHTML;
    const index = tags.indexOf(tagName);
    if (index === -1)
      return;

    //HACK: forcing update
    let updatedTags = [...tags];
    updatedTags.splice(index, 1);
    setTags(updatedTags);
  }

  // Create a tag element for UI representation of the tag list (green for positive tags, red for negative)
  function createTag(el)
  {
    const addative = el[0] === '-' ? false : true;

    return (
      <div id={"t:" + el} key={el + String(randomInt())} className="tag" onClick={removeTag}>
        <div className={(addative ? "add" : "remove")}>
          {el}
        </div>
      </div>
    );
  }

  // Clears the textfield and adds all entered tags to the tag list
  function OnSearchSubmit()
  {
    parseTagsFromInput();
    setSearchText("");
  }

  // Needed to allow text entry in the searchbox
  const handleSearchTextChange = (e) => {
    setSearchText(e.target.value);
  };

  return (
      <div id="searcharea">
        <div className="searchbarPadding">
          <div id="searchbar">
            <Form id="search-form" role="search" onSubmit={e => { e.preventDefault(); OnSearchSubmit();}}>
              <input
                id="SearchField"
                aria-label="search"
                type="search"
                name="SearchField"
                value={searchText}
                onChange={handleSearchTextChange}
              />
            </Form>
            <Form method="post">
              <button style={{width: "6rem"}} type="submit" onClick={e => { e.preventDefault(); OnSearchSubmit();}}>Search</button>
            </Form>
            <div id="tags-container">{ tags.map(el => createTag(el)) }</div>
          </div>
        </div>
        <ArticleGrid gridID='ArticlesGrid' 
          width={(windowSize.width * .98) - ((windowSize.width * .98) % 32)} /* snap to 32 bit value */
          cols={columnCount} /* Set the column count to number divisble by 32, truncate remainder */
          containerPadding={[0,0]}
          margin={[0,0]}
          defaultSize={[20, 20]} /* TODO: bind this to update with cols. Unsure how at this moment. */
          fullSize={[40, 40]}
          rowHeight={32} 
          tags={tags}>
        </ArticleGrid>
      </div>
  );
}